var AlgoliaFilterOperator;
(function(AlgoliaFilterOperator) {
    AlgoliaFilterOperator["OR"] = "OR";
    AlgoliaFilterOperator["NOT"] = "NOT";
    AlgoliaFilterOperator["AND"] = "AND";
    AlgoliaFilterOperator["AND_NOT"] = 'AND NOT';
})(AlgoliaFilterOperator || (AlgoliaFilterOperator = {}));
/**
 * Helper to return a filter based on id and value.
 * If the facet-value contains spaces, we should enclose it in quotes
 */ const getFilter = (id, value)=>{
    const escapedValue = typeof value === 'string' && value.includes(' ') ? `'${value}'` : value;
    return `${id}:${escapedValue}`;
};
function createAlgoliaFilters(filterableAttributes, operator, prefix) {
    if (!filterableAttributes.length) {
        return operator || prefix ? '' : [];
    }
    /**
   * Iterate over the filterableAttributes
   * Based on the type of value create a filter string
   */ const filters = filterableAttributes.reduce((prev, { id , value  })=>{
        /**
     * If the value is a simple string, return the value:
     * `<filterName>:<filterValue>`
     */ if (typeof value === 'string') {
            const result = getFilter(id, value);
            prev.push(result);
        }
        /**
     * If the value is an array, create a string with the OR operator between values encapsulated by `()`
     *  `(<filterName>:<filterValue1> OR <filterName>:<filterValue2> OR <filterName>:<filterValue2>)`
     */ if (Array.isArray(value)) {
            const result = value.map((val)=>getFilter(id, val)
            ).join(` ${AlgoliaFilterOperator.OR} `);
            const filterString = value.length > 1 ? `(${result})` : result;
            prev.push(filterString);
        }
        return prev;
    }, []);
    /**
   * If an operator or prefix is defined, adjust the string:
   * `<Prefix> <filterName1>:<filterValue> <Operator> <filterName2>:<filterValue>`
   */ if (operator || prefix) {
        return `${prefix ? `${prefix} ` : ''}${filters.join(` ${operator} `)}`;
    } else {
        return filters;
    }
}

export { AlgoliaFilterOperator, createAlgoliaFilters };
//# sourceMappingURL=create-algolia-filters.js.map
